import { useTranslation } from 'react-i18next'
import { useDiagramStore, useSelectionStore } from '@/stores'

export function StatusBar() {
  const { t } = useTranslation()
  const tableCount = useDiagramStore((state) => state.tables.length)
  const relationshipCount = useDiagramStore((state) => state.rels.length)
  const relMode = useSelectionStore((state) => state.relMode)
  const relationshipSourceTableId = useSelectionStore((state) => state.relationshipSourceTableId)
  const sourceTableName = useDiagramStore((state) =>
    relationshipSourceTableId
      ? state.tables.find((table) => table.id === relationshipSourceTableId)?.name ?? relationshipSourceTableId
      : null,
  )

  const hint = relMode
    ? sourceTableName
      ? t('status.hintRelationTarget', { name: sourceTableName })
      : t('status.hintRelationMode')
    : t('status.hintDefault')

  return (
    <div
      className="sticky bottom-0 z-20 flex h-7 shrink-0 items-center gap-3 border-t px-3 text-[10px]"
      style={{
        background: 'var(--bg-toolbar)',
        borderColor: 'var(--bg-app)',
        color: 'var(--text-dim)',
      }}
    >
      <span>{t('status.tables', { count: tableCount })}</span>
      <span>{t('status.relationships', { count: relationshipCount })}</span>
      <span className="truncate">{hint}</span>
      <span className="ml-auto" style={{ color: 'var(--color-success)' }}>{t('common.statusSaved')}</span>
    </div>
  )
}
